export default {
  setInit: (state) => {
    let storage = localStorage.getItem('agreedToPrivacy');

    if (storage) {
      const { date } = state.config;

      if (new Date(date) > new Date(storage)) {
        state.agreedToPrivacy = date;
        state.snackbar = true;
      } else {
        state.snackbar = false;
      }
    } else {
      state.snackbar = true;
    }
  },

  agreePrivacyPolicy(state) {
    if (state.config) {
      const { date } = state.config;

      localStorage.setItem('agreedToPrivacy', date);
      state.agreedToPrivacy = date;
      state.snackbar = false;
    }
  },

  setConfig(state, payload) {
    state.config = payload;
  },

  setSnackbar(state, payload) {
    state.snackbar = payload
  }
};
